import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as SINONIMO from 'src/assets/sinonimo.json';
import * as accents from 'remove-accents';


@Component({
  selector: 'app-professional-experiences-views-dialog',
  templateUrl: './professional-experiences-views-dialog.component.html',
  styleUrls: ['./professional-experiences-views-dialog.component.scss']
})
export class ProfessionalExperiencesViewsDialogComponent implements OnInit {

  experiences: Array<any> = [];
  currentExperience: any = null;
  userId: number;
  formVacancy: FormGroup;
  allDesirableJobs: Array<any> = [];
  sinonimos: Array<any> = (SINONIMO as any).default;
  allSinonimo
  filteredSinonimo
  filteredDesirableJobs

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<ProfessionalExperiencesViewsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    fb: FormBuilder,
  ) {
    this.userId = data.candidate.id;
    this.getExperiencies();

    this.allSinonimo = this.sinonimos;

    this.allDesirableJobs = this.sinonimos;
    this.filteredDesirableJobs = this.allDesirableJobs;

    this.formVacancy = fb.group({
      id: [null],
      lead_id: [null, Validators.required],
      company: [null, Validators.required],
      vacancy: [null, Validators.required],
      branch: [null, Validators.required],
      roleLevel: [null, Validators.required],
      specializationName: [null, Validators.required],
      description: [null, Validators.required],
      currentJob: [false, Validators.required],
      admissionDate: [null, [Validators.required, CustomValidators.beforeDate('departureDate', 'MMyyyy'), CustomValidators.date('MMyyyy')]],
      office: [null, Validators.required],
      departureDate: [null, [CustomValidators.departureDate('currentJob'), CustomValidators.maxDate(moment(), 'MMyyyy'), CustomValidators.date('MMyyyy')]],
      salary: [null],
      isPcd: [null],
      pcdDescription: [null],
      desiredJobTitle: [null],
      sinonimo: [null, Validators.required]
    });

    this.formVacancy.disable();

  }

  ngOnInit(): void {
    // this.dialogRef.updateSize();
    this.http.get('desired_job', { id: this.userId })
      .subscribe(
        (result: any) => {
          const { data } = result;
          this.formVacancy.patchValue({
            isPcd: data.is_pcd == 'true',
            pcdDescription: data.pcd_description,
            desiredJobTitle: data.desired_job_title != 'undefined' ? data.desired_job_title : null
          },
            { emitEvent: false }
          );
        })
  }

  getExperiencies() {
    const options = { id: this.userId, all: true }

    this.http.get('experience', options)
      .subscribe(
        (result: any) =>
          this.experiences = result.data
      ),
      (err: any) => {
        console.error(err);
      }
  }

  editProfessionalExperience(experience) {

    this.dialogRef.updateSize('1200px');
    this.currentExperience = experience;
    this.formVacancy.patchValue({
      id: experience.id,
      company: experience.organization,
      vacancy: experience.professional_name,
      branch: experience.branch,
      roleLevel: experience.role_level,
      specializationName: experience.specialization_name,
      currentJob: experience.final_date === null,
      description: experience.description,
      admissionDate: moment(experience.init_date, 'YYYY-MM-DD').format('MM/YYYY'),
      departureDate: experience.final_date ? moment(experience.final_date, 'YYYY-MM-DD').format('MM/YYYY') : null,
      office: experience.office,
      salary: parseFloat(experience.salary),
      sinonimo: experience.sinonimo
    })

  }

}
